import { useState } from "react";
import "./PasswordInput.css";

export default function PasswordInput({
  className = "",
  inputClassName = "",
  toggleClassName = "",
  showLabel = "Afficher le mot de passe",
  hideLabel = "Masquer le mot de passe",
  ...props
}) {
  const [visible, setVisible] = useState(false);
  const label = visible ? hideLabel : showLabel;

  return (
    <div className={`password-input ${className}`.trim()}>
      <input
        {...props}
        type={visible ? "text" : "password"}
        className={`password-input__control ${inputClassName}`.trim()}
      />
      <button
        type="button"
        className={`password-input__toggle ${toggleClassName}`.trim()}
        onClick={() => setVisible((current) => !current)}
        aria-label={label}
        title={label}
      >
        {visible ? "🙈" : "👁️"}
      </button>
    </div>
  );
}
